
<div class="card panel-default">
        <!-- page Header -->
        <!--<div class="card-header header-style text-center">
            <h6>
                <i class="fa fa-plus fa-3x icons-style" aria-hidden="true" placement="left" ngbTooltip="{{ 'ADD' | translate }}" [routerLink]="[ 0 ]"></i>
            </h6>
        </div>-->
        <!-- <div class="master-form">
            <app-fast-search [appearFastSearch]="false" [appCodes]="[1020,1024,1025,1153,2005]" name="fastSearchData" (searchKeys)="onSearchClick($event)"
                ngDefaultControl></app-fast-search>
        </div> -->
        <!--  -->
        <p-dataTable tableStyleClass="table table-bordered table-striped" [value]="Data" [rows]="10" [paginator]="true" [pageLinks]="3"
            [rowsPerPageOptions]="[5,10,20,50,100]" >
            <p-column *ngIf="requestType == 1" field="serial" header="{{ 'VACCODE' | translate }}" [sortable]="true"></p-column>
            <p-column *ngIf="requestType == 2" field="serial" header="{{ 'REQUESTCODE ' | translate }}" [sortable]="true"></p-column>
            <p-column field="empId" header="{{ 'EMPID' | translate }}" [sortable]="true"></p-column>
            <p-column field="fullnameAr" header="{{ 'EMPName' | translate }}" [sortable]="true"></p-column>
            <p-column *ngIf="requestType == 1" field="vacNameNameAr" header="{{ 'VACATIONTYPE' | translate }}" [sortable]="true"></p-column>
            <p-column field="hrManagementNameAr" header="{{ 'MANAGMENT' | translate }}" [sortable]="true"></p-column>
            <p-column *ngIf="requestType == 2" field="requestTypeNameAr" header="{{ 'REQTYPE' | translate }}" [sortable]="true"></p-column>
            <p-column *ngIf="requestType == 1" field="period" header="{{ 'PERIOD' | translate }}" [sortable]="true"></p-column>
            <p-column *ngIf="requestType == 1" header="{{ 'VACSTARTFROM' | translate }}">
                <ng-template pTemplate="options" let-row="rowData">
                    <i>
                        {{row['vacStartDate'] | date:'dd/MM/yyyy'}}
                    </i>
                </ng-template>
            </p-column>
            <p-column header="{{'AGREE' | translate }}">
                <ng-template pTemplate="options" let-row="rowData">
                    <div class="form-check">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" [(ngModel)]="row.accept" name="accept" (change)="onAsseptChange(row)">
                            <span class="custom-control-indicator"></span>
                        </label>
                    </div>
                </ng-template>
    
            </p-column>
            <p-column header="{{'DISAGREE' | translate }}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div class="form-check">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" [(ngModel)]="row.reject" name="reject" (change)="onAsseptChange(row)">
                                <span class="custom-control-indicator"></span>
                            </label>
                        </div>
                    </ng-template>
        
                </p-column>


                <p-column styleClass="col-button">
                    <ng-template pTemplate="options" let-row="rowData">
                      <icon-action (clicked)="onRowIconClick($event , row)" [appCodes]="[1013]"></icon-action>
                    </ng-template>
                  </p-column>
        </p-dataTable>
    </div>



    <div>
        <block-modal-container #popup >
                <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
        </block-modal-container>
      </div>
